module.exports = __webpack_public_path__ + "static/pic06-790163927190029c35e18b4c7410780f.jpg";